module.exports = __webpack_public_path__ + "static/fonts/iconfont.9c4c3303.woff";